var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.8284 14.704L25.0208 23.8964C25.4113 24.2869 25.4113 24.9201 25.0208 25.3106L23.6065 26.7248C23.216 27.1153 22.5829 27.1153 22.1923 26.7248L12.9999 17.5324L15.8284 14.704Z","key":0}),React.createElement("circle",{"cx":"10","cy":"10.5","r":"10","fill":"currentColor","key":1}),React.createElement("circle",{"cx":"10","cy":"10.5","r":"6","fill":"#226E50","key":2})]);
}

SearchInline.defaultProps = {"width":"26","height":"28","viewBox":"0 0 26 28","fill":"none"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
